import { useMediaQuery } from '@material-ui/core';
import imgLogo from '@pe-libs/react-components/build/assets/common/logos/logo.svg';
import PeImage from '@pe-libs/react-components/build/components/PeImage';
import PeLink from '@pe-libs/react-components/build/components/PeLink';
import { getPublicEnvironmentValue } from '@pe-libs/react-components/build/lib/environment';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import { useTheme } from '@pe-libs/react-components/build/theme';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import LanguageSwitch from '#components/languageSwitch';
import useRedirect from '#hooks/useRedirect';
import { selectIsEmployerHost } from '#modules/app/selectors/settings';
import messages from './messages';
import useStyles from './styles';

const Header: FC = () => {
  const styles = useStyles();
  const formatMessage = useIntlMessage();
  const theme = useTheme();
  const { urlToLivePage } = useRedirect();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isEmployerHost = useSelector(selectIsEmployerHost);
  const wwwHost = getPublicEnvironmentValue('WWW_HOST', isEmployerHost);
  const registerLink = `${wwwHost}/register`;

  return (
    <div className={styles.headerContainer}>
      <header className={styles.header}>
        <PeLink className={styles.logoLink} href={urlToLivePage('home')} title={formatMessage(messages.hoverLogo)}>
          <div className={styles.logo}>
            <PeImage
              alt={formatMessage(messages.hoverLogo)}
              src={imgLogo as string}
              layout="fixed"
              width={189}
              height={56}
            />
          </div>
        </PeLink>
        <div className={styles.rightSection}>
          <PeLink
            href={registerLink}
            variant="body1"
            title={formatMessage(messages.registerText)}
            className={styles.registerLink}
          >
            {formatMessage(messages.registerText)}
          </PeLink>
          <LanguageSwitch isHoverable={isDesktop} />
        </div>
      </header>
    </div>
  );
};

export default Header;
